import { FormInstance } from 'antd';

export const resetTaskFormFields = (field: string, form: FormInstance<any>) => {
  switch (field) {
    case 'departmentId':
      return form.setFieldsValue({
        departmentId: undefined,
        jobId: undefined,
      });
    case 'assignTo':
      return form.setFieldsValue({
        companyId: undefined,
        departmentId: undefined,
        jobId: undefined,
        assignedMembersIds: undefined,
      });
    case 'jobId':
      return form.setFieldsValue({ jobId: undefined });
    default:
      return;
  }
};
